module.exports = __webpack_public_path__ + "img/white_square_mobile.25dfa750.png";